import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store'
import {
  IncomingPayroll,
  IncomingPayrollBatch,
  IncomingRunningPayrollBatch,
  PayrollSummary,
  RunningPayrollBatch,
  TdsCalculationBatchInput,
  TdsCalculationInput,
  TdsCalculationResult
} from './payroll.state'
import { EmployeeSalary } from '../employee-salary/employee-salary.state'

export const payrollBatchesActions = createActionGroup({
  source: 'Payroll Batches',
  events: {
    'Load Payroll Batches': props<{ financialYear: string; belongsTo: string }>(),
    'Load Payroll Batches Success': props<{ payrollBatches: IncomingPayrollBatch[] }>(),
    'Load Payroll Batches Failure': props<{ error: string }>(),

    'Finalize Payroll': props<{
      batchId: string
      dateOfPayment: string
      modeOfPayment: string
      paidBy: string
    }>(),
    'Finalize Payroll Success': props<{ batch: IncomingPayrollBatch }>(),
    'Finalize Payroll Failure': props<{ error: string }>(),

    'Delete Payroll Batch': props<{ id: string }>(),
    'Delete Payroll Batch Success': props<{ id: string }>(),
    'Delete Payroll Batch Failure': props<{ error: string }>()
  }
})

export const runningPayrollActions = createActionGroup({
  source: 'Running Payroll',
  events: {
    //Used by managePayroll to provide initial data to run-payroll component
    'Setup Running Payroll': props<{ batchData: IncomingRunningPayrollBatch }>(),
    'Clear Running Payroll': emptyProps(),

    'Load Running Payroll': props<{
      payPeriodStart: string
      payPeriodEnd: string
      belongsTo: string
    }>(),
    'Load Running Payroll Success': props<{ updatedBatch: IncomingRunningPayrollBatch }>(),
    'Load Running Payroll Failure': props<{ error: string }>(),

    //Load Previous Salaries
    'Load Previous Salaries': props<{
      requests: { employeeId: string; currentSalaryEffectiveFrom: string }[]
    }>(),
    'Load Previous Salaries Success': props<{
      previousSalaries: Record<string, EmployeeSalary | null>
    }>(),
    'Load Previous Salaries Failure': props<{ error: string }>(),

    'Clear Previous Salaries': emptyProps(),

    //Load Arrear Lop Days
    'Load Arrear Lop Days': props<{
      requests: { employeeId: string; businessId: string; periodStart: string; periodEnd: string }[]
    }>(),
    'Load Arrear Lop Days Success': props<{
      arrearLopDays: Record<string, number>
    }>(),
    'Load Arrear Lop Days Failure': props<{ error: string }>(),

    'Clear Arrear Lop Days': emptyProps(),

    'Save Running Payroll Draft': props<{ batchData: RunningPayrollBatch }>(),
    'Save Running Payroll Draft Success': props<{ batchData: IncomingRunningPayrollBatch }>(),
    'Save Running Payroll Draft Failure': props<{ error: string }>(),

    'Update Running Payroll Status': props<{ id: string; status: string; payrollIds: string[] }>(),
    'Update Running Payroll Status Success': props<{ batchData: IncomingRunningPayrollBatch }>(),
    'Update Running Payroll Status Failure': props<{ error: string }>()
  }
})

export const userPayrollActions = createActionGroup({
  source: 'User Payroll',
  events: {
    'Load User Payroll': props<{
      payPeriodStart: string
      payPeriodEnd: string
      employeeId: string
    }>(),
    'Load User Payroll Success': props<{ payroll: IncomingPayroll }>(),
    'Load User Payroll Failure': props<{ error: string }>(),

    'Load Latest User Payroll Date': props<{ employeeId: string }>(),
    'Load Latest User Payroll Date Success': props<{ latestPayrollDate: string }>(),
    'Load Latest User Payroll Date Failure': props<{ error: string }>()
  }
})

export const payrollSummaryActions = createActionGroup({
  source: 'Payroll Summary',
  events: {
    'Load Summary': props<{ employeeId: string; financialYear: string; joiningDate: Date }>(),
    'Load Summary Success': props<{ summary: PayrollSummary }>(),
    'Load Summary Failure': props<{ error: string }>()
  }
})

export const tdsCalculationActions = createActionGroup({
  source: 'Tds Preview',
  events: {
    'Load Batch Tds Preview': props<{ payload: TdsCalculationBatchInput }>(),
    'Load Batch Tds Preview Success': props<Record<string, TdsCalculationResult>>(),
    'Load Batch Tds Preview Failure': props<{ error: string }>(),

    'Load Tds Preview': props<{ payload: TdsCalculationInput }>(),
    'Load Tds Preview Success': props<{ result: TdsCalculationResult; employeeId: string }>(),
    'Load Tds Preview Failure': props<{ error: string }>()
  }
})

export const resetPayrollSummary = createAction('[Payroll Summary] Reset Summary')
